const dataAccessMethods = require('../../dataAccessMethods');
const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const Blockly = require('blockly');
class WorkflowLogic extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        switch (hNodeType) {
            case 'showConfirmationMessage':
                code.message = blocklyBlock.getFieldValue('confirmationMessage');
                if (blocklyBlock.getFieldValue('onPropertyChanged').toUpperCase() !== 'FALSE') {
                    code.propertyName = blocklyBlock.getFieldValue('propertyName');
                    if (blocklyBlock.getFieldValue('namespace')) {
                        code.foreignNamespace = blocklyBlock.getFieldValue('namespace');
                        code.foreignRelation = blocklyBlock.getFieldValue('relation');
                    }
                }
                break;
            default:
                throw new Error(`Unknown filter type: ${hNodeType}`);
        }
        return JSON.stringify(code);
    }
    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        switch (hNodeType) {
            case 'showConfirmationMessage':
                {
                    blocklyBlock.setInputsInline(false);
                    blocklyBlock.setTooltip(
                        'Display a confirmation message when a botton is clicked. If the (optional) property is specified, use {oldValue} or {newValue} for the respective values in the message.'
                    );
                    blocklyBlock
                        .appendDummyInput()
                        .setAlign(Blockly.ALIGN_RIGHT)
                        .appendField('  Message:')
                        .appendField(new Blockly.FieldTextInput('Are you sure?'), 'confirmationMessage');
                    blocklyBlock
                        .appendDummyInput()
                        .setAlign(Blockly.ALIGN_RIGHT)
                        .appendField(new Blockly.FieldCheckbox(), 'onPropertyChanged')
                        //need to spread this over 2 lines
                        //as otherwise it will truncate it and show ... instead of full text
                        .appendField('Only show message when')
                        .appendField('the following property was changed:');
                    blocklyBlock
                        .appendDummyInput()
                        .setAlign(Blockly.ALIGN_RIGHT)
                        .appendField('  Optional Namespace:')
                        .appendField(
                            new Blockly.FieldDropdown(() => dataAccessMethods.getNamespaces(true)),
                            'namespace'
                        )
                        .setAlign(Blockly.ALIGN_RIGHT)
                        .appendField('  Optional Relation:')
                        .appendField(
                            new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId, true)),
                            'relation'
                        )
                        .setAlign(Blockly.ALIGN_RIGHT)
                        .appendField('  Property Name:')
                        .appendField(new Blockly.FieldTextInput(''), 'propertyName');
                }
                break;
            default:
                throw new Error(`Unknown filter type: ${hNodeType}`);
        }
    }
}
module.exports = WorkflowLogic;
